import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
//import { ChartsModule } from 'ng2-charts';

import { AppRoutingModule } from '../app-routing.module';
import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { MainModule } from '../main/main.module';

import { SynthesisComponent } from './synthesis/synthesis.component';
import { PiechartComponent } from './piechart/piechart.component';
import { NgxEchartsModule } from 'ngx-echarts';
import { TranslocoRootModule } from '../transloco/transloco-root.module';

//let echartsURL = window['__env'].baseUrl+'/miiar/assets/echarts';


@NgModule({
  declarations: [
    SynthesisComponent,
    PiechartComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslocoRootModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts')
    }),
    AppRoutingModule,
    CustomMaterialModule,
    MainModule
  ],
  exports: [SynthesisComponent],
})
export class SynthesisModule { }
